module.exports = __webpack_public_path__ + "static/media/bicycle_s.9ad08f4a.jpg";